__webpack_require__.aG = (body) => ((__webpack_handle_async_dependencies__, __webpack_async_result__) => {
	const gen = body(__webpack_handle_async_dependencies__, __webpack_async_result__);
	const step = (key, arg) => {
		const info = gen[key](arg);
		if (info.done) return;
		Promise.resolve(info.value).then((value) => (step("next", value)), (err) => (step("throw", err)));
	};
	step("next");
});